import SelectionOutlinedBox from './SelectionOutlinedBox';

export default SelectionOutlinedBox;
